<a class="pos-relative"
   [class.in-wishlist]="inWishlist"
   [class.not-in-wishlist]="!inWishlist"
   rel="nofollow"
   id="wishlist-qty"
   [attr.aria-label]="'Wishlist Qty' | translate"
   [minibasketToggle]="{wishlist: true}"
   #buttonRef>
    <i aria-hidden="true"
       [ngClass]="wishlist.qty > 0 ? 'icon-wishlist-fill col-23' : 'icon-wishlist-thin'"
       #iconRef></i>

    <!-- add animation -->
    <i class="icon-wishlist-fill will-animate col-23 ng-hide ng-hide-animate"
       aria-hidden="true"
       #iconHeartRef></i>
</a>
